import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useQueryParams } from '../../core/hooks'

import { PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { useLoggedInUser } from '../../account/hooks'
import { CREATE_PRIORITY_TASK_MUTATION } from '../graphql/mutations'
import { PRIORITY_TASKS_QUERY } from '../graphql/queries'
import {
  CREATE_PRIORITY_TASK,
  FETCH_PRIORITY_TASKS,
} from '../redux/action-types'

const useCreatePriorityTaskMutation = () => {
  const dispatch = useDispatch()
  const { settings: userSettings } = useLoggedInUser()

  const {
    currentPage = PAGINATION.DEFAULT_PAGE,
    pageSize = userSettings?.pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
  } = useQueryParams()

  const { isCreateLoading: isLoading, createError: error } =
    useSelector(store => store.priorityTasks.priorityTasks) || {}

  const onSuccess = useCallback(
    () =>
      apolloService.query({
        query: PRIORITY_TASKS_QUERY,
        variables: { pagination: { currentPage, pageSize } },
        dispatch,
        action: FETCH_PRIORITY_TASKS,
      }),
    [currentPage, dispatch, pageSize],
  )

  const mutate = useCallback(
    data => {
      apolloService.mutate({
        mutation: CREATE_PRIORITY_TASK_MUTATION,
        variables: { data },
        dispatch,
        action: CREATE_PRIORITY_TASK,
        onSuccess,
      })
    },
    [dispatch, onSuccess],
  )

  return [mutate, { isLoading, error }]
}

export default useCreatePriorityTaskMutation
